import { FC, ReactElement, useEffect, useState } from 'react';
import path from 'path';
import { Redirect, useRoute } from 'wouter';
import { useGame } from '../../stores/game';
import ServiceScreen from '../service-screen';

export const CheckIfPlayerIsInGame: FC<{
  children?: ReactElement;
}> = props => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [playerIsInGame, setPlayerIsInGame] = useState<boolean>(false);

  const [match, params] = useRoute<GameRouteParams>('/:gamePlayId/:rest*');
  const playerFromGamePlayId = useGame(
    ({ playerFromGamePlayId }) => playerFromGamePlayId
  );
  const playerExists = useGame(({ playerExists }) => playerExists);

  const pathname = path.join('/', params.gamePlayId, 'not-in-game');

  console.log('🔍 [CheckIfPlayerIsInGame] State:', {
    isLoading,
    playerIsInGame,
    gamePlayId: params.gamePlayId,
    rest: params.rest,
    pathname
  });

  useEffect(() => {
    const init = async () => {
      console.log('🔍 [CheckIfPlayerIsInGame] Starting init...');
      try {
        const playerData = await playerFromGamePlayId(params.gamePlayId);
        console.log('🔍 [CheckIfPlayerIsInGame] Player data:', playerData);

        const exists = playerExists(playerData.playerId);
        console.log('🔍 [CheckIfPlayerIsInGame] Player exists:', exists);

        setPlayerIsInGame(exists);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        console.log('🔍 [CheckIfPlayerIsInGame] Finished init');
      }
    };

    if (isLoading && !playerIsInGame) init();
  }, [playerFromGamePlayId, playerIsInGame, isLoading]);

  if (!match) {
    console.log('❌ [CheckIfPlayerIsInGame] No match!');
    return <span>This component is not loaded under the correct path</span>;
  }

  if (isLoading) {
    console.log('⏳ [CheckIfPlayerIsInGame] Loading...');
    return <ServiceScreen text="Loading..." />;
  }

  if (!playerIsInGame) {
    console.log('❌ [CheckIfPlayerIsInGame] Player not in game!');
    return <Redirect key={pathname} to={pathname} />;
  }

  console.log('✅ [CheckIfPlayerIsInGame] Player in game!');
  return props.children;
};

type GameRouteParams = {
  gamePlayId: string;
  rest: string;
};
